import * as React from "react";
import Box from "@mui/material/Box";
import FormInput from "../forms/FormInput";
import AppForm from "../forms/AppForm";
import { Divider, TextField } from "@mui/material";
import AppButton from "../common/AppButton";
import { addSpecilitiesValidationSchema } from "../forms/validationSchemas";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import LoadingSpinner from "../common/Loading";
import { editspeciality } from "../../features/speciality/specialitySlice";
import AppErrorMessage from "../common/AppErrorMessage";
import SpecialityTags from "./specialityTag";
import SpecialityDiseaseTags from "./SpecialityDiseaseTags";
import SpecialityTreatmentTags from "./SpecialityTreatmentTags";

interface IProps {
  handleEdit: () => void;
  setOpenEditSnackbar: () => void;
  speciality: any;
  dto: any;
  getSpeciality: any;
}

const SpecialityEditModal = ({
  handleEdit,
  setOpenEditSnackbar,
  speciality,
  getSpeciality,
}: IProps) => {
  const [formState, setFormState] = React.useState({
    spec_id: speciality?.id,
    name: speciality?.name,
    description: speciality?.description,
  });
  const dispatch = useAppDispatch();
  const {
    isRegisterSpecialitiesError,
    isSpecialitiesLoading,
    registerSpecialitiesMessage,
  } = useAppSelector((state) => state.speciality);
  const [openModal, setOpenModal] = React.useState(false);
  const handleCloseModal = () => setOpenModal(false);

  const handleSubmit = (values: any) => {
    dispatch(
      editspeciality({
        spec_id: values.spec_id,
        name: values.name,
        description: values.description,
      })
    ).then((res) => {
      if (res.payload.success === true) {
        getSpeciality();
        setOpenEditSnackbar();
        handleEdit();
      }
    });
  };

  return (
    <>
      <AppForm
        validationSchema={addSpecilitiesValidationSchema}
        initialValues={formState}
        onSubmit={handleSubmit}
      >
        {isSpecialitiesLoading ? (
          <LoadingSpinner style={{ minHeight: "58vh" }} />
        ) : (
          <Box
            sx={{
              px: 2,
              pt: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "-45px",
              justifyContent: "center",
            }}
          >
            <Box sx={{ width: "100%", mt: 3 }}>
              <FormInput name="name" as={TextField} label=" Name" fullWidth />
            </Box>
            <Box sx={{ width: "100%", mt: 3 }}>
              <FormInput
                name="description"
                as={TextField}
                label="Description"
                fullWidth
                multiline={true}
              />
              <Box sx={{ width: "100%", mt: 3 }}>
                {isRegisterSpecialitiesError && (
                  <AppErrorMessage message={registerSpecialitiesMessage} />
                )}
              </Box>
              <Box sx={{ width: "100%", mt: 5 }}>
                <AppButton
                  onClick={handleSubmit}
                  title="Edit"
                  sx={{ float: "right", margin: "10px", marginTop: "-25px" }}
                />
                <Divider style={{ width: "100%" }} />
              </Box>
            </Box>
          </Box>
        )}
      </AppForm>
      <h3 style={{ marginLeft: "15px" }}>Tags</h3>
      <SpecialityTags
        handleClose={handleCloseModal}
        speciality={speciality}
        getCall={getSpeciality}
      />
      <h3 style={{ marginLeft: "15px" }}>Disease</h3>
      <SpecialityDiseaseTags
        handleClose={handleCloseModal}
        speciality={speciality}
      />
      <h3 style={{ marginLeft: "15px" }}>Treatment</h3>
      <SpecialityTreatmentTags
        handleClose={handleCloseModal}
        speciality={speciality}
      />
    </>
  );
};

export default SpecialityEditModal;
